const MAP = {
  "Nowe zamówienie": "bg-blue-500/20 text-blue-300 border-blue-500/30",
  "Wysłane do produkcji": "bg-indigo-500/20 text-indigo-300 border-indigo-500/30",
  "Zrealizowane": "bg-emerald-500/20 text-emerald-300 border-emerald-500/30",
  "Wysłane Garwolin": "bg-cyan-500/20 text-cyan-300 border-cyan-500/30",
  "Wysłane Nowy Sącz": "bg-sky-500/20 text-sky-300 border-sky-500/30",
  "Wysłane do klienta": "bg-purple-500/20 text-purple-300 border-purple-500/30",
  "Zamknięte": "bg-zinc-500/20 text-zinc-300 border-zinc-500/40",
  "Do weryfikacji": "bg-amber-500/25 text-amber-300 border-amber-500/40",
};

export const StatusBadge = ({ status }) => (
  <span data-testid="status-badge" className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider ${MAP[status] || "bg-slate-500/20 text-slate-300 border-slate-500/30"}`}>
    {status}
  </span>
);
